import { useQuery } from "@tanstack/react-query";

import { components } from "@/@types/api";
import { INSIGHTS_BACKEND_URL } from "@/lib/axios";
import { QueryConfig } from "@/lib/react-query";
import { axiosApi } from "@/Utils";

import { useScenarioBuilderClient } from "../../api/hooks/useScenarioBuilderClient";
import { getCustomerModelMetadata as getGeographiesV2 } from "./v2/getCustomerModelMetadata";

type GetGeographiesResponse = components["schemas"]["GetGeographiesResponse"];

const getGeographies = (): Promise<GetGeographiesResponse> => {
  return axiosApi.get("/api/v2/scenarios-new/geographies", {
    baseURL: INSIGHTS_BACKEND_URL,
  });
};

type QueryFnType = typeof getGeographies | typeof getGeographiesV2;

type UseGeographiesOptions = {
  config: QueryConfig<QueryFnType>;
  isScenariosApiEnabled?: boolean;
};

export const useGeographies = ({
  config,
  isScenariosApiEnabled = false,
}: UseGeographiesOptions) => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  return useQuery({
    ...config,
    queryKey: ["geographies", isScenariosApiEnabled],
    queryFn: isScenariosApiEnabled
      ? () => getGeographiesV2({ scenarioBuilderClient })
      : getGeographies,
    select: (data) => data.geographies,
  });
};
